import { FormikProvider, getIn, useFormik } from "formik";
import { IRenter } from "../../../../../../../types/renter.type";
import { useReactivatePlan } from "./customHook/useReactivatePlan";
import ButtonWithLoader from "../../../../../../../common/components/ui/loading/ButtonLoading";
import { ImageBondVehicleRenterRow } from "./field/ImageBondVehicleRenterRow";
import VelotrackActivate from "../../UploadInfoApis/VelotrackActivate";
import ZapSignActivate from "../../UploadInfoApis/ZapSignActivate";
import { createContract } from "../../../../../services/integration.api";
import ZapSignConfirmation from "../../UploadInfoApis/ZapSignConfirmation";
import { useEffect, useState } from "react";
import { reactivatePlan } from "../../../../../../../common/services/renters.api";
import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context";
import { saveVehicleRecords } from "../../../../../../../common/services/vehicles.api";
import { DateSubscriptionFormik } from "../../../../forms/fields/DateSubscriptionFormik";
import { AvailableVehiclesFieldFormik } from "../../../../forms/fields/AvailableVehiclesFieldFormik";

type ReactivatePlanProps = {
  data: IRenter;
}
export default function ReactivatePlan(props: ReactivatePlanProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { notifySuccess, notifyError } = useToastContext()

  let vehicleId;
  const { oldPlanName, unlinkDate, initialRegisters,
    renterId, contractData, signatureInfo, handleSignature,
    initialDateSubscription, renterName, licensePlate } = useReactivatePlan(props.data);
  const renter = props.data

  const vehicleHistory = renter?.desactivationData?.vehicleHistory

  let partnerId;

  if (vehicleHistory && vehicleHistory.length > 0) {
    partnerId = vehicleHistory[vehicleHistory.length - 1].partnerId;
  }


  const formik = useFormik({
    initialValues: {
      vehicleId,
      renterId: renterId,
      initialDateSubscription,
      registers: initialRegisters,
      subscriptionInitialDate: new Date(),
    },
    onSubmit: async (data) => {
      setIsSubmitting(true);
      try {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        const reactivatePlanData = {
          renterId: renterId,
          vehicleId: data.vehicleId,
          subscriptionInitialDate: data.subscriptionInitialDate,
        }
        const result = await reactivatePlan(reactivatePlanData, renterId);

        if (!result.ok) {
          notifyError(result.message as string)
        }

        notifySuccess("Plano reativado com sucesso");

        if (result.ok) {
          const savePhotoDelivery = {
            renterId: renterId,
            vehicleId: data.vehicleId,
            photos: data.registers,
            nameRenter: renterName,
            licensePlate: vehicle.licensePlate,
          }
          const resultPhoto = await saveVehicleRecords(savePhotoDelivery)

          if (!resultPhoto.ok) {
            notifyError(resultPhoto.message as string)
            return
          }

          notifySuccess("Fotos salvas com sucesso");
        }
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  const vehicle = getIn(formik.values, 'vehicle')
  const registers = getIn(formik.values, 'register');
  contractData.vehicleId = vehicle?._id;

  useEffect(() => {
    formik.setFieldValue('register', initialRegisters);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // O array vazio garante que isso seja executado apenas uma vez quando o componente é montado


  useEffect(() => {
    if (vehicle && vehicle?._id && vehicle?._id !== formik.values.vehicleId) {
      formik.setFieldValue('vehicleId', vehicle?._id);
    }
  }, [vehicle, formik]);


  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <section aria-labelledby="old-plan-section">
          <label className="font-semibold text-sm">Plano antigo do cliente</label>
          <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
            {oldPlanName}
          </p>
          <label className="font-semibold text-sm">Data em que a moto foi desvinculada</label>
          <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
            {licensePlate} - {unlinkDate}
          </p>
        </section>

        <section aria-labelledby="new-plan-section">
          <label className="font-semibold text-sm">Selecione o novo veiculo</label>
          <AvailableVehiclesFieldFormik
            partnerId={partnerId}
            companyId={renter.companyId}
            required={true}
          />
          <DateSubscriptionFormik className="" />

          <div className="grid gap-2">
            <h2 className="text-2xl font-semibold mb-4">Registros do veículo</h2>
            {(!vehicle || !vehicle._id) && <small className="text-redPrimary">Selecione um veículo para adicionar as fotos</small>}

            {registers?.map((doc, index) => (
              <div key={index} className={`space-x-3 px-3 py-2 my-0 rounded ${index % 2 ? 'bg-gray/5' : 'bg-gray/25'}`}>
                <ImageBondVehicleRenterRow
                  initialData={doc || {}}
                  name={`registers.${index}`}
                  onRemoveClick={() => formik.setFieldValue('registers', registers.filter((_, i) => i !== index))}
                  prefix="entrega" />
              </div>
            ))}

            <button
              type="button"
              className=" disabled:text-black/50"
              onClick={() => {
                formik.setFieldValue(`registers.${registers.length}`, { type: '', content: '', verified: false })
              }}
            >
              + registro
            </button>
          </div>
        </section>


        <div className="flex justify-end mb-6">
          <ButtonWithLoader
            type="button" isLoading={isSubmitting} onClick={formik.handleSubmit}>
            Reativar Plano
          </ButtonWithLoader>
        </div>

        <div>
          <VelotrackActivate
            onSave={function (): void {
              throw new Error('Function not implemented.');
            }}
            renterId={renterId} />
        </div>

        <div>
          <ZapSignActivate
            disabled={false}
            onSave={function (): void {
              throw new Error('Function not implemented.');
            }} contractData={contractData}
            handleSignature={handleSignature}
            contractFn={createContract} />
        </div>
        <div>
          {signatureInfo?.ok && (
            <ZapSignConfirmation
              contractInfo={signatureInfo}
            />)}
        </div>
      </FormikProvider>
    </form>
  );
}